import { render, staticRenderFns } from "./Incoming.vue?vue&type=template&id=64cde4b2&scoped=true"
import script from "./Incoming.vue?vue&type=script&lang=ts"
export * from "./Incoming.vue?vue&type=script&lang=ts"
import style0 from "./Incoming.vue?vue&type=style&index=0&id=64cde4b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cde4b2",
  null
  
)

export default component.exports